
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { NoticeArea } from '../noticeArea';

@Component({ components: { NoticeArea } })
export default class StandbyReleaseSection extends Vue {
  @Prop({ default: '' }) readonly templateSubject!: string;

  @Prop({ default: '' }) readonly templateBody!: string;

  @Prop({ default: false }) readonly isEmergencyTimeSet!: boolean;

  @Prop({ default: false }) readonly disabled!: boolean;

  draftSubject = '';

  draftBody = '';

  dirty = false;

  @Watch('templateSubject', { immediate: true })
  onTemplateSubjectChange(value: string) {
    if (this.dirty) return;
    this.draftSubject = value ?? '';
  }

  @Watch('templateBody', { immediate: true })
  onTemplateBodyChange(value: string) {
    if (this.dirty) return;
    this.draftBody = value ?? '';
  }

  onSubjectInput(value: string) {
    this.draftSubject = value;
    this.updateDirty();
  }

  onBodyInput(value: string) {
    this.draftBody = value;
    this.updateDirty();
  }

  updateDirty() {
    this.dirty = this.draftSubject !== this.templateSubject
      || this.draftBody !== this.templateBody;
  }
}
